"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var CountryResource = /** @class */ (function (_super) {
    tslib_1.__extends(CountryResource, _super);
    function CountryResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountryResource.endpoint = '/countries';
    CountryResource.MODEL_NAME = 'country';
    return CountryResource;
}(base_1.default));
exports.default = CountryResource;
//# sourceMappingURL=country.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/country.js
// module id = C+bz
// module chunks = 0